import { Globe } from "lucide-react";

export const CountryBreakdown = ({ data, light = false, testid = "country-breakdown", max = 10 }) => {
  const rows = (data || []).slice(0, max);
  const total = (data || []).reduce((a, x) => a + x.count, 0);
  const box = light ? "rounded-xl border border-slate-200 p-5" : "rounded-lg border border-[#242C3D] bg-[#141A24]/70 p-6";
  return (
    <div className={box} data-testid={testid}>
      <h3 className={`font-semibold mb-4 flex items-center gap-2 ${light ? "text-slate-900" : "font-display"}`}><Globe className={`w-4 h-4 ${light ? "text-slate-400" : "text-indigo-400"}`} /> Leads by country</h3>
      {!total ? (
        <p className={`text-sm ${light ? "text-slate-400" : "text-slate-500"}`}>No leads yet. Add a Country question to the form to capture this.</p>
      ) : (
        <ul className="space-y-3">
          {rows.map((x) => (
            <li key={x.country} data-testid={`${testid}-row`}>
              <div className="flex justify-between text-sm mb-1">
                <span className={x.country === "Not provided" ? (light ? "text-slate-400" : "text-slate-500") : light ? "text-slate-700" : "text-slate-300"}>{x.country}</span>
                <span className={`font-mono ${light ? "text-slate-500" : "text-slate-400"}`}>{x.count} · {Math.round((x.count / total) * 100)}%</span>
              </div>
              <div className={`h-1.5 rounded ${light ? "bg-slate-100" : "bg-[#0B0F17]"}`}><div className="h-full rounded bg-cyan-500" style={{ width: `${(x.count / total) * 100}%` }} /></div>
            </li>
          ))}
          {data.length > max && <li className={`text-xs ${light ? "text-slate-400" : "text-slate-500"}`}>+ {data.length - max} more countries</li>}
        </ul>
      )}
    </div>
  );
};
